<footer>
  <div class="container">
    <div class="block1">
      <div class="title">MARIO</div>
      <div class="subtitle">
        Mario – стиль, який<br/> говорить за вас!
      </div>
    </div>
    <div class="block2">
      <div class="text">+380 (98) 102-03-04</div>
      <div class="text">{{'support@mario.ua'}}</div>
    </div>
    <div class="block3">
      <div class="links">
        <div class="link">Політика конфіденційності</div>
        <div class="link">Політика конфіденційності2</div>
      </div>
      <div class="copyright">© 2025 Всі права захищені</div>
    </div>
  </div>
</footer>
